<template>
  <b-card class="mb-4" no-body>
    <template #header>
      <b-row>
        <b-col :xs="bubble ? 11 : 12">
          <h5>{{ title }}</h5>
        </b-col>
        <b-col lg="1" v-if="bubble" v-b-tooltip.hover :title="bubble">
          <font-awesome-icon class="text-white" icon="info" />
        </b-col>
      </b-row>
    </template>
    <b-card-body>
      <b-row class="mt-2">
        <b-col>
          <h2 v-if="!mainPercent && !mainTimeSpan">
            {{ this.card.value | formatNumber }}
          </h2>
          <h2 v-else-if="!mainPercent && mainTimeSpan">
            {{ this.card.value | formatTimeSpan }}
          </h2>
          <h2 v-else>{{ this.card.value | formatPercent }}</h2>
          <i
            v-if="this.card.evo_real && this.card.evo_real > 0"
            class="la la-arrow-right text-success la-lg rotate-315"
          />
          <i
            v-if="this.card.evo_real && this.card.evo_real <= 0"
            class="la la-arrow-right text-danger la-lg"
            style="transform: rotate(45deg)"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          :class="evo_real >= 0 ? 'text-success' : 'text-danger'"
          md="6"
          sm="12"
        >
          <div class="mt">
            <h6 v-if="!mainPercent && !mainTimeSpan">
              {{ this.card.evo_real | formatNumber }}
            </h6>
            <h6 v-else-if="!mainPercent && mainTimeSpan">
              {{ this.card.evo_real | formatTimeSpan }}
            </h6>
            <h6 v-else>{{ this.card.evo_real | formatPercent }}</h6>
            <p class="text-muted mb-0 mr">
              <small>{{ $t("legends.real_evolution") }}</small>
            </p>
          </div>
        </b-col>
        <b-col :class="evo_percent >= 0 ? 'text-success' : 'text-danger'" md="6" sm="12">
          <div class="mt">
            <h6>{{ this.card.evo_percent | formatPercent }}</h6>
            <p class="text-muted mb-0">
              <small>{{ $t("legends.in_percent") }}</small>
            </p>
          </div>
        </b-col>
      </b-row>
      <div v-if="info" class="d-flex flex-wrap justify-content-between">
        <div class="mt">
          <p class="text-muted">{{ info }}</p>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    value: { type: Number, required: true },
    evo_real: { type: Number, default: null },
    evo_percent: { type: Number, default: null },
    mainPercent: { type: Boolean, default: false },
    mainTimeSpan: { type: Boolean, default: false },
    info: { type: String, default: null },
    bubble: { type: String, default: null },
    period_info: { type: String, default: null },
  },
  data() {
    return {
      card: {
        title: null,
        value: null,
        evo_real: null,
        evo_percent: null,
      },
    };
  },
  created() {
    this.card.title = this.title;
    this.card.value = this.value;
    this.card.evo_real = this.evo_real;
    this.card.evo_percent = this.evo_percent;
  },
};
</script>

<style lang="scss" scoped>
.card {
  margin-top: 1vw;
}
small.period {
    font-size: 0.6em;;
}
</style>
